import { ConfigurationState, ConfigurationStateActionType, ConfigurationStateActionEnum } from "./interfaces";

const ConfigurationStateReducer = (
    configurationState: ConfigurationState,
    action: ConfigurationStateActionType
  ): ConfigurationState => {
    switch (action.type) {
        
        case ConfigurationStateActionEnum.SET_BIMVAULT_URL:
            return {
            ...configurationState,
            bimVaultApiUrl: action.data
            }

        case ConfigurationStateActionEnum.SET_THREE_DEE_URL:
          return {
          ...configurationState,
          threeDeeApiUrl: action.data
          }

        case ConfigurationStateActionEnum.SET_CORE_API_URL:
          return {
          ...configurationState,
          coreApiUrl: action.data
          }

        case ConfigurationStateActionEnum.SET_CONFIGURATION:
          return action.data
        
    default:
            throw new Error(`Bad reducer action.`)
        
    }
};

export default ConfigurationStateReducer;
